<template>
  <div>

    <div>
      <el-upload class="upload-demo" action="" :before-upload="upLoad" :show-file-list="false"
        style="display: inline-block;" :disabled="!addBtnPriv || !addBtn || !btnIsAdmin">
        <el-button class="btn btn1" icon="el-icon-circle-plus-outline" :disabled="!addBtnPriv || !addBtn || !btnIsAdmin"
          :class="!addBtnPriv || !addBtn || !btnIsAdmin ? 'btnDisable' : ''">{{ $t('message.button.add') }}
        </el-button>

      </el-upload>

      <el-button class="btn btn2" icon="el-icon-delete" @click="removeAttachment"
        :disabled="!removeBtnPriv || !removeBtn || !btnIsAdmin"
        :class="!removeBtnPriv || !removeBtn || !btnIsAdmin ? 'btnDisable' : ''">
        {{ $t('message.button.delete') }}
      </el-button>

      <el-button class="btn btn3" icon="el-icon-paperclip" @click="downloadAttachment"
        :disabled="!fileBtnPriv || !btnIsAdmin"
        :class="!fileBtnPriv || !btnIsAdmin ? 'btnDisable' : ''">{{ $t('message.button.download') }}
      </el-button>

      <el-button class="btn btn4" icon="el-icon-reading" @click="previewFile"
        :disabled="!fileReadBtnPriv || !btnIsAdmin" :class="!fileReadBtnPriv ? 'btnDisable || !btnIsAdmin' : ''">
        {{ $t('message.button.preview') }}
      </el-button>

      <div class="edit-table" style="float: right;overflow: hidden;height: 33px;">
        <el-button class="btn btn7" icon="el-icon-document-checked" @click="saveValue"
          :disabled="!addBtnPriv || !addBtn || !btnIsAdmin"
          :class="!addBtnPriv || !addBtn || !btnIsAdmin ? 'btnDisable' : ''">
          {{ $t('message.button.save') }}
        </el-button>
        <el-button class="btn btn8" icon="el-icon-circle-close" @click="cancelSave"
          :disabled="!addBtnPriv || !addBtn || !btnIsAdmin"
          :class="!addBtnPriv || !addBtn || !btnIsAdmin ? 'btnDisable' : ''">{{ $t('message.button.cancel') }}
        </el-button>


      </div>
    </div>

    <div>

      <vxe-grid ref='xGrid' v-bind="gridOptions" @edit-disabled="editDisabledEvent" @cell-dblclick="noEdit"
        @checkbox-change="checkboxChangeEvent" @checkbox-all="checkboxChangeEvent">
        <template #bottom>
          <div class="alert-message">
            <span class="alert-message-content">
              <div>{{ $t('message.title.Checked') + selectRecords.length + $t('message.title.resultsNums') }} {{
                $t('message.title.totalResults') + totalRecords + $t('message.title.resultsNums')}}</div>
            </span>
          </div>
        </template>
      </vxe-grid>
    </div>

    <el-dialog v-if="cascaderShow" class="searchAddBomList" :title="$t('message.title.add')"
      :visible.sync="cascaderShow" @close="closeCascaderShow">
      <div style="height:270px;">
        <div style="margin:60px auto;padding-left:50px">
          <el-cascader v-model="cascaderValue" :options="cascaderList" :props="cascaderProps" :show-all-levels="true"
            size="small" ref="cascaderAddr" style="width:75%"></el-cascader>
          <el-button size="small" type="primary" style="margin-left:10px" @click="getCascadeValue">{{
            $t("message.button.affirm") }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<style>
.searchAddBomList .el-dialog__body {
  padding: 0 20px 20px 20px !important;
}

.el-table th.gutter {
  display: table-cell !important;
}

.link_ {
  color: #4b92ff;
  cursor: pointer;
}

.link_:hover {
  color: #4b92ff;
  cursor: pointer;
  border-bottom: 1px solid #4b92ff;
}
</style>

<script>
import axios from "axios";
export default {
  data() {
    return {

      // save_img1 : require("@/assets/save1.png"),
      // save_img2 : require("@/assets/save2.png"),

      selectRecords: [],
      totalRecords: "",
      gridOptions: {
        keepSource: true,
        resizable: true,
        border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: 'id',
        height: "530",
        size: "small",
        columns: [{
          type: 'checkbox',
          width: 50,
          fixed: null
        }],
        data: [],
        treeConfig: {
          lazy: true,
          children: 'children',
          hasChild: 'hasChildren',
          loadMethod: this.loadChildrenMethod
        },
        editConfig: {
          trigger: 'dblclick',
          mode: 'row',
          showIcon: false,
          activeMethod: this.activeRowMethod,
          showStatus: true,
        },
        sortConfig: {
          trigger: 'cell'
        },
      },
      cols: [], //表头
      editShow: false,

      //权限
      removeBtnPriv: false,
      fileBtnPriv: false,
      fileReadBtnPriv: false,
      addBtnPriv: false,
      btnIsAdmin: true, //是否为项目经理
      btnIsProjectAdmin: true, //是否为项目负责人
      isExecuter: true, //是否为执行者

      //btn业务逻辑
      addBtn: true,
      removeBtn: true,

      cascaderShow: false,
      cascaderValue: [],
      cascaderList: [],
      cascaderProps: {}
    }
  },
  mounted() { },
  methods: {
    checkboxChangeEvent({ records }) {
      const $grid = this.$refs.xGrid;
      this.selectRecords = records;
    },
    addAttachment() {
      // console.log("addAttachment");
    },
    upLoad(file) {
      console.log(file);

      var objInfo = {
        ... this.$store.state.objectId,
        //id: this.$store.state.objId_,
        //classId: this.$store.state.classId_,
        //subClassId: this.$store.state.subClassId_,
      }

      let fd = new FormData();
      fd.append('id', this.$store.state.objectId.id);
      fd.append('classId', this.$store.state.objectId.classId);
      fd.append('subClassId', this.$store.state.objectId.subClassId);
      fd.append('changeId', 0);
      fd.append('changeClassId', 0);
      fd.append('changeSubClassId', 0);
      fd.append("fileSize", file.size);
      fd.append('fileName', file.name);
      // console.log(fd);

      let fileBag = new FormData();
      fileBag.append("file", file);
      fileBag.append('id', this.$store.state.objectId.id);
      fileBag.append('classId', this.$store.state.objectId.classId);
      fileBag.append('subClassId', this.$store.state.objectId.subClassId);
      fileBag.append('changeId', 0);
      fileBag.append('changeClassId', 0);
      fileBag.append('changeSubClassId', 0);
      fileBag.append('fileName', file.name);
      fileBag.append("fileSize", file.size);

      var vm = this;

      var vm = this;
      axios.post("/swift-file/files/checkFileNameAndRevFDS", fd).then(function (res) {
        console.log(res);
        if (res.data.object.code == 200) {
          vm.updateFileAgain(fileBag);
        } else if (res.data.object.code == 501) {
          vm.$confirm(vm.$t('message.confirm.overwrite'), vm.$t('message.tips.tip'), {
            confirmButtonText: vm.$t('message.button.affirm'),
            cancelButtonText: vm.$t('message.button.cancel'),
            type: 'warning'
          }).then(() => {
            vm.updateFileAgain(fileBag);
          }).catch(() => {
            vm.$message({
              type: 'info',
              message: vm.$t('message.tips.deleteCancel')
            });
          });
        } else {
          vm.$message.error(res.data.object.message);
          return false;
        };

      }).catch(function (error) {
        console.log(error);
      });
    },

    updateFileAgain(obj) {
      var vm = this;
      axios.post("/swift-file/files/uploadFile", obj).then(function (res) {
        // console.log(res);
        if (res.data.code == 200) {
          vm.$message({
            message: res.data.message,
            type: "success",
          });
          vm.getAttachments();
        }
      });
    },

    removeAttachment() {
      // console.log("removeAttachment");
      var removeRow = this.$refs.xGrid.getCheckboxRecords();
      // console.log(removeRow);
      var deletedFilesId = [];
      var vm = this;
      if (removeRow.length == 0) {
        vm.$message({
          message: this.$t('message.tips.dele_data'),
          type: "warning",
        });
      } else {
        //console.log(removeRow);
        this.$confirm(this.$t('message.confirm.deleteData'), this.$t('message.tips.tip'), {
          confirmButtonText: this.$t('message.button.affirm'),
          cancelButtonText: this.$t('message.button.delete'),
          type: 'warning'
        }).then(() => {
          for (var i = 0; i < removeRow.length; i++) {
            var obj = {};
            obj.id = removeRow[i].fileId;
            deletedFilesId.push(obj);
          };
          var deletedFilesIdUrl = {
            deletedFilesId: deletedFilesId
          };
          // console.log(delAIData);
          axios.post('/swift-file/files/deleteFile', deletedFilesIdUrl).then(function (res) {
            if (res.data.code == 200) {
              vm.$message({
                message: res.data.message,
                type: 'success'
              });
              // console.log(res);
              vm.getAttachments();
            }
          })
            .catch(function (error) {
              console.log(error);
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    },
    previewFile() {
      // console.log("previewFile");
      // var url = 'http://192.168.1.159:8888/group1/M00/00/04/wKgBn2FL9_qANjVPAAA7-d2dxZ840.docx?attname=2%E9%81%93%E7%AE%97%E6%B3%95%E9%9D%A2%E8%AF%95%E9%A2%98.docx'; //要预览文件的访问地址
      // console.log(url);
      var previewFileRow = this.$refs.xGrid.getCheckboxRecords();
      // console.log(previewFileRow);
      // var downloadFilesId = [];
      var vm = this;
      if (previewFileRow.length == 0) {
        return false
      } else if (previewFileRow.length > 1) {
        vm.$message({
          message: this.$t('message.warning.choice'),
          type: "warning",
        });
      } else {
        var getFile = {
          fileId: previewFileRow[0].fileId,
          type: 'preview',//preview 不在记录在历史tab，所以有些参数没传
        };

        axios.get(`swift-file/files/getFilePath${this.params(getFile)}`)
          .then(res => {
            // console.log(res);
            var url = res.data.object.path;
            //var preLink = url.substring(7);
            // console.log(preLink);
            //var iplink = preLink.substring(0,preLink.indexOf(':'));
            //iplink = 'localhost';
            // console.log(link);
            //window.open('http://'+iplink+':9999/onlinePreview?url='+encodeURIComponent(Base64.encode(url)));
            var preLink = res.data.object.previewUrl;
            var iWidth = window.screen.width - window.screen.width / 3;                          //弹出窗口的宽度;
            var iHeight = window.screen.height;                                                 //弹出窗口的高度; 
            var iTop = 50;
            var iLeft = (window.screen.width - iWidth) / 2;
            window.open(preLink + '/onlinePreview?url=' + encodeURIComponent(Base64.encode(url)), '_blank', 'height=' + iHeight + ',width=' + iWidth + ',top=' + iTop + ',left=' + iLeft + '');
          })
      }
    },
    downloadAttachment() {
      var downloadRow = this.$refs.xGrid.getCheckboxRecords();
      console.log(downloadRow);
      var downloadFilesId = [];
      var vm = this;
      if (downloadRow.length == 0) {
        return false
      } else if (downloadRow.length > 1) {
        vm.$message({
          message: this.$t('message.warning.choice'),
          type: "warning",
        });
      } else {

        var getFile = {
          ... this.$store.state.objectId,
          //id: this.$store.state.objId_,
          //classId: this.$store.state.classId_,
          //subClassId: this.$store.state.subClassId_,
          changeId: 0,
          changeClassIds: 0,
          changeSubClassId: 0,
          fileId: downloadRow[0].fileId,
          fileName: downloadRow[0][0],
          type: 'download',//新加的参数是给记录到历史tab里用
        };

        axios.get(`swift-file/files/getFilePath${this.params(getFile)}`)
          .then(res => {
            console.log(res);

            // let c = 'http://192.168.1.159'+ res.data.object.path;
            var link = document.createElement("a");
            // link.download = this.messageInfo.fileName;//下载文件名
            link.download = res.data.object.name;
            link.href = res.data.object.path;
            // console.log(link.href);
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(link.href);
          })


        // const getFileUrl = `/files/downloadFile${this.params(getFile)}`;
        // const params = {
        // };
        // const {
        //   data: respond
        // } = this.$http({
        //     method: 'GET',
        //     url: getFileUrl,
        //     // responseType必须值,否则文件下载后乱码
        //     responseType: 'arraybuffer',
        //     params: params
        // })
        // // } = await this.$http.get(getFileUrl);
        // // if (respond.status === 200) {
        //   // console.log(respond);
        //   let respondData = respond;
        //   var blob = new Blob([respondData], {
        //       type: "application/octet-stream",
        //   });
        //   var link = document.createElement("a");
        //   // link.download = this.messageInfo.fileName;//下载文件名
        //   link.download = downloadRow[0][0];
        //   link.href = window.URL.createObjectURL(blob);
        //   // console.log(link.href);
        //   document.body.appendChild(link);
        //   link.click();
        //   window.URL.revokeObjectURL(link.href);
      }
    },
    //拷贝downloadAttachment的代码，只是改了downloadRow，和getFile。fileId getFile。fileName
    clickRowDownloadAttachment(clickRow) {
      var downloadRow = clickRow;
      console.log(downloadRow);
      var downloadFilesId = [];
      var vm = this;
      if (downloadRow.length == 0) {
        return false
      } else if (downloadRow.length > 1) {
        vm.$message({
          message: this.$t('message.warning.choice'),
          type: "warning",
        });
      } else {
        var getFile = {
          id: downloadRow.itemId,
          classId: downloadRow.itemClassId,
          subClassId: downloadRow.itemSubClassId,

          changeId: this.$store.state.objectId.id,
          changeClassId: this.$store.state.objectId.classId,
          changeSubClassId: this.$store.state.objectId.subClassId,
          fileId: downloadRow.fileId,
          fileName: downloadRow[0],
          type: 'download',//新加的参数是给记录到历史tab里用
        };

        axios.get(`/swift-file/files/getFilePath${this.params(getFile)}`).then((res) => {
          console.log(res);

          // let c = 'http://192.168.1.159'+ res.data.object.path;
          var link = document.createElement("a");
          // link.download = this.messageInfo.fileName;//下载文件名
          link.download = res.data.object.name;
          link.href = res.data.object.path;
          // console.log(link.href);
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(link.href);
        });

      }
    },

    noEdit({ row, columnIndex }) {
      // let systemName = window.sessionStorage.getItem("systemName");
      // if(systemName.indexOf('奥斯汀') != -1){
      // console.log(row, columnIndex);
      // console.log(this.gridOptions.columns);
      let fileNameIndex = 1;
      for (let k = 0; k < this.gridOptions.columns.length; k++) {
        if (this.gridOptions.columns[k].attid == this.Constants.attachmentFileName) {
          fileNameIndex = Number(this.gridOptions.columns[k].field) + 1;
        }
      };
      console.log(fileNameIndex);
      if (columnIndex == fileNameIndex && this.fileBtnPriv) {
        //console.log("downloadAttachment");
        this.clickRowDownloadAttachment(row);
      };
      // }

      if (column.editRender.cascaderType && this.editTable) {
        this.cascaderList = column.editRender.cascadeOptions;
        let m = row[[column.property]];
        if (column.editRender.props.multiple) {
          this.cascaderValue = m ? m.map((i) => { return this.getParentIdList(this.cascaderList, i) }) : ''
          this.cascaderProps.multiple = true;
        } else {
          this.cascaderProps.multiple = false;
          this.cascaderValue = m;
        }
        this.cascaderProps.checkStrictly = true;
        this.tempData = { row, column }
        this.cascaderShow = true;
        console.log(this.cascaderValue);
      }
    },
    saveValue() {
      // console.log("saveValue");
      var xGrid_ = this.$refs.xGrid;
      let updateRecords = this.$refs.xGrid.getUpdateRecords(); //获取修改的行
      // console.log(updateRecords);
      var updateFile = [];
      if (updateRecords.length !== 0) { //判断行内那些值有改动
        for (let i = 0; i < updateRecords.length; i++) {
          var num = xGrid_.getRowIndex(updateRecords[i]);
          // console.log(updateRecords[i]);
          // console.log(num);
          // console.log(this.cols);
          var cols_length = this.cols;
          for (let j = 0; j < cols_length.length; j++) {
            var updateNewData = xGrid_.isUpdateByRow(updateRecords[i], "" + j);
            if (updateNewData) {
              // console.log(cols_length[j]+"---------"+updateRecords[i][j]+"---------"+updateRecords[i].rowId);
              // var obj = {};
              // var quantity = cols_length[j];
              // obj.id = updateRecords[i].rowId;
              // obj[quantity] = updateRecords[i][j];
              // updateFile.push(obj);
              for (let k = 0; k < this.gridOptions.columns.length; k++) {
                var obj = {};
                if (cols_length[j] == this.gridOptions.columns[k].attid) {
                  var quantity = cols_length[j];
                  obj.id = updateRecords[i].rowId;
                  if (this.gridOptions.columns[k].editRender.props) {
                    //处理多选和单选
                    if (this.gridOptions.columns[k].editRender.props.multiple) {
                      obj[quantity] = updateRecords[i][j].join(";");
                    } else if (
                      this.gridOptions.columns[k].editRender.props.type ==
                      "datetime"
                    ) {
                      console.log(updateRecords[i][j]);
                      // obj[quantity] = updateRecords[i][j].format("yyyy-MM-ddThh:mm:ss");
                      obj[quantity] = this.format(
                        updateRecords[i][j],
                        "yyyy-MM-ddThh:mm:ss"
                      );
                      console.log(obj[quantity]);
                    } else {
                      if (updateRecords[i][j] == null) {
                        obj[quantity] = "";
                      } else {
                        obj[quantity] = updateRecords[i][j];
                      }
                    }
                  } else {
                    if (updateRecords[i][j] == null) {
                      obj[quantity] = "";
                    } else {
                      obj[quantity] = updateRecords[i][j];
                    }
                  };
                  updateFile.push(obj);
                }
              }
            }
          }
        };
        var updateFileData = { //post更改的值
          tableId: 201,
          objId: {
            ... this.$store.state.objectId,
            //id: this.$store.state.objId_,
            //classId: this.$store.state.classId_,
            //subClassId: this.$store.state.subClassId_,
            version: this.version
          },
          updateFile: updateFile
        };
        // console.log(updateFileData);
        var vm = this;
        axios.post('/pmdm/items/updateTable', updateFileData)
          .then(function (res) {
            //console.log(res);
            if (res.data.code == 200) {
              vm.$message({
                message: res.data.message,
                type: 'success'
              });
              vm.getAttachments();
              xGrid_.revertData();
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      };
    },
    cancelSave() {
      this.$refs.xGrid.revertData(); //清除所有保存，删除，添加记录
    },
    editDisabledEvent() {

    },
    async getAttachments() {
      var obj_get = { //获取change
        ... this.$store.state.objectId,
        //id: this.$store.state.objId_,
        //classId: this.$store.state.classId_,
        //subClassId: this.$store.state.subClassId_,
        changeId: 0,
        changeClassId: 0,
        changeSubClassId: 0,
        tableId: 201
      };
      var loadTableUrl = `/pmdm/items/loadTable${this.params(obj_get)}`;
      const { //获取标题
        data: res
      } = await this.$http.get(loadTableUrl);
      this.gridOptions.columns = this.getNewTableTitleData(res);
      this.rols_text = this.getNewTableContentData(res);
      this.gridOptions.data = this.rols_text;
      this.totalRecords = res.object.table.totalRecords;
      this.cols = res.object.table.columnInfo.ids;
    },

    loadUserPriv() {

      this.getPriv().then(res => {
        console.log(res.data.object.hasPriv);
        const hasPriv = res.data.object.hasPriv;
        let isSuperAdmin = this.$store.state.isSuperAdmin;
        // let privList = this.getUserContextPriv().filter(i => i.classId == this.$store.state.objectId.subClassId).map(j =>j.type);
        // this.addBtnPriv = isSuperAdmin|| privList.includes(17) || hasPriv;
        // this.removeBtnPriv = isSuperAdmin || privList.includes(4) || hasPriv;
        // this.fileBtnPriv = isSuperAdmin || privList.includes(21) || hasPriv;
        // this.fileReadBtnPriv = isSuperAdmin || privList.includes(30) || hasPriv;

        // 附件页签中的添加，删除，下载，预览，四个权限增加了标准，在页面中根据后端的传值，决定是否可用
        console.log(res);
        this.addBtnPriv = isSuperAdmin || res.data.object.fileAddPriv || hasPriv;
        this.removeBtnPriv = isSuperAdmin || res.data.object.delPriv || hasPriv;
        this.fileBtnPriv = isSuperAdmin || res.data.object.downLoadPriv || hasPriv;
        this.fileReadBtnPriv = isSuperAdmin || res.data.object.previewPriv || hasPriv;
      })
      if (!window.location.pathname == "/ProjectAttachment") {//项目附件
        this.btnIsAdmin = true;
      };
    },

    getPriv() {
      const change_info = this.get_change_info || this.$store.state.change_info;
      var obj_get = {
        ... this.$store.state.objectId,
        //id: this.$store.state.objId_,
        //classId: this.$store.state.classId_,
        //subClassId: this.$store.state.subClassId_,
        ...change_info,
        tableId: 201,
      };
      // var loadTableUrl = `/pmdm/items/loadTable${this.params(obj_get)}`;
      return axios.get(`/pmdm/relationship/hasCustomerPriv${this.params(obj_get)}`,)
    },
  },
  computed: {
    loadIsProjectAdmin() {
      return this.$store.state.isProjectAdmin;
    },
    loadIsProjectDirector() {
      return this.$store.state.isProjectDirector;
    },
    loadIsProjectExecuters() {
      return this.$store.state.isProjectExecuters;
    },
  },
  created() {
    // console.log("created");
    this.getAttachments();
    this.loadUserPriv();
    setTimeout(() => {
      this.loading = false;
    }, 500);
  },
  watch: {
    loadIsProjectAdmin: {
      handler(val) {
        this.btnIsProjectAdmin = val;
        console.log(val);
      },
      deep: true,
      immediate: true,
    },
    loadIsProjectDirector: {
      handler(val) {
        //this.btnIsProjectDirector = val;
        let projectCreatedBy = this.$store.state.projectCreatedBy;
        let userId = window.sessionStorage.getItem("userContext");
        userId = JSON.parse(userId).id;
        if (!this.btnIsProjectAdmin && !val && userId !== projectCreatedBy) {
          this.btnIsAdmin = false;
        } else {
          this.btnIsAdmin = true;
        };
      },
      deep: true,
      immediate: true,
    },
    loadIsProjectExecuters: {
      handler(val) {
        //this.btnIsProjectDirector = val;
        let isSupAdmin = this.$store.state.isSuperAdmin;
        if (!this.btnIsAdmin && !val && !isSupAdmin) {
          this.btnIsAdmin = false;
        } else {
          this.btnIsAdmin = true;
        };
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>